import { useEffect, useState } from 'react';
import axios from 'axios';
import { getApiBaseUrl } from '../apiBase';
import { getActiveSchoolId } from '../utils/activeSchool';
import { getEffectiveNavRole } from '../utils/roles';

/** Включена ли в настройках школы касса и оборудование (для меню РМК). */
export function useSchoolCashDeskEnabled() {
    const [enabled, setEnabled] = useState(false);
    const [loading, setLoading] = useState(true);
    const role = getEffectiveNavRole();

    useEffect(() => {
        if (role !== 'Owner' && role !== 'Admin') {
            setEnabled(false);
            setLoading(false);
            return;
        }
        const schoolId = getActiveSchoolId();
        if (!schoolId) {
            setEnabled(false);
            setLoading(false);
            return;
        }
        let cancelled = false;
        const token = localStorage.getItem('token');
        const api = axios.create({
            baseURL: getApiBaseUrl(),
            headers: token ? { Authorization: `Bearer ${token}` } : {}
        });
        (async () => {
            try {
                const res = await api.get('/school/my', { params: { schoolId } });
                if (!cancelled) setEnabled(!!res.data?.hasCashDeskAndEquipment);
            } catch {
                if (!cancelled) setEnabled(false);
            }
            if (!cancelled) setLoading(false);
        })();
        const onStorage = () => {
            const sid = getActiveSchoolId();
            if (sid === schoolId) return;
            setLoading(true);
        };
        const onRefresh = () => {
            const sid = getActiveSchoolId();
            if (!sid) {
                setEnabled(false);
                return;
            }
            api.get('/school/my', { params: { schoolId: sid } })
                .then(res => setEnabled(!!res.data?.hasCashDeskAndEquipment))
                .catch(() => setEnabled(false));
        };
        window.addEventListener('storage', onStorage);
        window.addEventListener('school-settings-updated', onRefresh);
        return () => {
            cancelled = true;
            window.removeEventListener('storage', onStorage);
            window.removeEventListener('school-settings-updated', onRefresh);
        };
    }, [role]);

    return { enabled, loading };
}
